const windowNameKeys = {
	'EXCHANGE': 'exchange',
	'CASINO': 'casino',
	'PROMOTION': 'promotion',
	'LIVECHAT': 'live-chat',
	'CONTACT': 'contact',
	'FOOTER': 'footer-items',
	'APP_DOWNLOAD': 'app-download',
} as const;

export default windowNameKeys;
